import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/$locale/smartbanking/documents')({
  component: Page,
});

function Page() {
  const { t } = useTranslation();
  return (
    <header>
      <h1>{t('topMenu.documents')}</h1>
    </header>
  );
}
